/**
 * Resultado generado por el servidor al solicita la comprobación de permisos para el
 * usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
import KeyValuePair from '@/modules/core/support/KeyValuePair';

export class CheckAuthorizationResult {
    /**
     * Permisos permitidos
     *
     * Claves de los permisos que el usuario posee
     */
    public granted: string[] = []

    /**
     * Permisos rechazados
     */
    public rejected: Array<{
        path: string,
        rejectionMessage: string,
    }> = []

    /**
     * Convierte la información obtenida desde la api en una entidad
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            granted: data.granted,
            rejected: data.rejected.map((r: KeyValuePair) => ({
                path: r.path,
                rejectionMessage: r.rejection_message,
            })),
        })
    }

    /**
     *
     * @param input
     */
    public merge (input: CheckAuthorizationResult): CheckAuthorizationResult {
        this.granted = this.granted.concat(input.granted)
        input.rejected.forEach(r => {
            if (!this.rejected.find(ar => ar.path === r.path)) {
                this.rejected.push(r)
            }
        })

        return this
    }

    /**
     * Comprueba si un permiso esta otorgado
     *
     * @param path
     */
    public isGranted (path: string) {
        return !!this.granted.find(g => g === path)
    }
}
